export default (theme) => ({
  attachment: {
    display: 'flex',
    backgroundColor: theme.palette.background.white,
    border: '1px solid',
    borderColor: theme.palette.link.main,
    padding: '5px 8px',
    boxSizing: 'border-box',
    borderRadius: 16,
    cursor: 'pointer',
    color: theme.palette.link.main,
  },
  disabledAttachment: {
    pointerEvents: 'none',
    borderColor: theme.palette.disabled.main,
    color: theme.palette.disabled.main,
  },
  attachmentText: {
    marginLeft: 10,
    fontSize: 14,
    userSelect: 'none',
  },
  attachIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 22,
    height: 22,
    borderRadius: '50%',
    backgroundColor: theme.palette.link.main,
    '& svg': {
      width: '80%',
      fill: theme.palette.background.white,
    },
  },
  disabledAttachIcon: {
    backgroundColor: theme.palette.disabled.main,
  },
  deleteFileButton: {
    width: 22,
    height: 22,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'none',
    borderRadius: '50%',
    border: 'none',
    marginLeft: 5,
    color: theme.palette.font.main,
    cursor: 'pointer',
    transition: 'background .2s ease-in, color .2s linear',
    '& svg': {
      transition: 'fill .2s linear',
    },
    '&:hover': {
      background: '#ffbbbb',
    },
    '&:hover svg': {
      fill: '#ffffff',
    },
  },
});
